export default __webpack_public_path__ + "static/media/arrow-right-icon.25c44537.svg";